import React, { useEffect, useContext } from 'react';
import exportConfig from '../../config';
import Skeleton from 'react-loading-skeleton';
import { endpointContext } from '../../contexts/endpointContext';

const CurrentlyInQCAllUsers = ({ data, loading, error }) => {

	const endpointContextCurrentlyInQCAllUsers = useContext(endpointContext)

	//console.log(data)
	return (
		<div class="dashboard-card">
			<div
				class="dashboard-card-header"
				//data-tooltip-id="dashboard-system-status"
			>
				<div className="row">
					<h6 className="ms-2">Captures in QC</h6>
				</div>
			</div>
			<div class="dashboard-card-body">
				{loading ? (
					<Skeleton />
				) : data && data.length > 0 ? (
					<div className="table ">
						<table
							className="table dashboard-stats-table"
							style={{ width: '100%' }}
						>
							<thead>
								<tr>
									<th>User</th>
									<th className="text-center">Commodity</th>
									<th className="text-center">Caps in queue</th>
								</tr>
							</thead>
							<tbody>
								{data.map((user, idx) => (
									<tr key={idx}>
										<td>{user.user_id}</td>
										<td className="text-center">
											{
												endpointContextCurrentlyInQCAllUsers.dbData.allCommodities.filter(
													(comm) => comm.id === user.commodity_id
												)[0].siteTypeStr
											}
										</td>
										<td className="text-center">{user.count}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				) : (
					<h5>No captures currently in QC</h5>
				)}
			</div>
		</div>
	);
};

export default CurrentlyInQCAllUsers
